import { FormInput, Grid } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Bevestiging"
      description='Typ hieronder "ik heb alle gegevens correct ingevuld" indien u alle vragen in deze vragenlijst nauwkeurig en correct heeft ingevuld. Klik daarna op "volgende" om het document in te sturen.'
      maxWidth={1000}
    >
      <Grid container spacing={2}>
        <FormInput
          name="confirmation_text"
          placeholder="ik heb alle gegevens correct ingevuld"
          xs={12}
          required
          rules={{
            validate: (value) =>
              (value ?? '').toLowerCase().trim() ===
              'ik heb alle gegevens correct ingevuld'
                ? undefined
                : true,
          }}
        />
      </Grid>
    </StepWrapper>
  );
}
